import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const CatalogSearchPage = lazy(
  () => import('./pages/catalog-search/catalog-search.page'),
);
const DetectionDetailPage = lazy(
  () => import('./pages/detection-detail/detection-detail.page'),
);

export const UnifiedContentLibraryRoutes = () => {
  return (
    <Routes>
      <Route path="/search" element={<CatalogSearchPage />} />
      <Route path="/detections" element={<DetectionDetailPage />} />
    </Routes>
  );
};
